import React, { Component } from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import { Button, Table, ButtonGroup, Glyphicon, Row, Col, FormControl } from 'react-bootstrap'
import Api from '../../../Global/Modules/Api'

const FETCH_URL = "api/news/admin"
class MededelingOverzicht extends Component {
    constructor() {
        super();
        this.handleDelete = this.handleDelete.bind(this)
        this.handleClick = this.handleClick.bind(this)
        this.handlePaginationClick = this.handlePaginationClick.bind(this)
        this.getOpleiding = this.getOpleiding.bind(this)
        this.handleChangePageSize = this.handleChangePageSize.bind(this)
        this.state = {
            opleiding: [],
            Title: "sorting",
            DateCreated: "sorting",
            pagination: {
                totalPages: 0,
                currentPage: 0,
                pageSize: 0,
                totalCount: 0,
                orderBy: "",
            },
            currentFetchUrl: FETCH_URL // To know where to fetch (to refresh companies) if a company is deleted
        }
    }
    handleChangePageSize(e) {
        this.setState({ pagination: { ...this.state.pagination, pageSize: e.target.value } })
        this.getOpleiding(FETCH_URL + "?PageSize=" + e.target.value + (this.state.pagination.searchQuery == "" ? "" : "&SearchQuery=" + this.state.pagination.searchQuery) + (this.state.pagination.orderBy == "" ? "" : "&OrderBy=" + this.state.pagination.orderBy))
    }
    // To pass parameters to event handlers while using property initializer syntax, we need to use currying.   
    handleDelete = id => event => {
        event.preventDefault()
        const FETCH_URL_DELETE = `api/news/${id}`
        if (window.confirm('Are you sure you wish to delete this item?')) {
            Api.print(`DELETE ${FETCH_URL_DELETE}`)
            Api.DeleteApi(FETCH_URL_DELETE).then(response => {
                this.getOpleiding(this.state.currentFetchUrl) // Update the companies list
            })
        }
    }
    handleSortingClick(e) {
        var newSort = this.state.pagination.orderBy.indexOf(e) >= 0 ? this.state.pagination.orderBy.indexOf("asc") >= 0 ? this.state.pagination.orderBy.replace("asc", "desc") : this.state.pagination.orderBy.replace("desc", "asc") : e + " asc";
        this.setState({ Title: "sorting" })
        this.setState({ DateCreated: "sorting" })
        this.setState({ [e]: newSort.indexOf("asc") >= 0 ? "sorting_asc" : "sorting_desc" })
        this.setState({ pagination: { ...this.state.pagination, orderBy: newSort } })
        this.getOpleiding(FETCH_URL + "?OrderBy=" + newSort + "&PageSize=" + this.state.pagination.pageSize)
    }
    handlePaginationClick(e) {
        const FETCH_URL2 = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.setState({ currentFetchUrl: FETCH_URL2 })
        this.getOpleiding(FETCH_URL2)
    }
    getOpleiding(fetchUrl) {
        Api.print(`GET ${fetchUrl}`)
        Api.GetTableApi(fetchUrl, this.handlePaginationClick).then(response => {
            Api.print("Response")
            Api.print(response)
            this.setState({ pagination: response.pagination }) // Pagination object 
            return response.data.json() // Data -> companies object
        }).then(objectData => {
            Api.print("opleiding)")
            Api.print(objectData)
            Api.print("----------")
            if (objectData !== undefined)
                this.setState({ opleiding: objectData.news }); // Companies object
        })
    }
    componentDidMount() {
        this.getOpleiding(FETCH_URL)
    }
    handleClick(e) {
        const fetchUrl = e === "prev" ? this.state.pagination.prev : this.state.pagination.next;
        this.getOpleiding(fetchUrl)
        this.setState({ currentFetchUrl: fetchUrl })
    }

    render() {
        let opleiding = this.state.opleiding
        return (
            <div>
                <LinkContainer to="/admin/mededelingen/toevoegen">
                    <Button>
                        Mededeling toevoegen
                    </Button>
                </LinkContainer>
                <br /><br />
                <Row>
                    <Col md={1} sm={1}>
                        <FormControl name='pageSize' componentClass="select" placeholder="select" onChange={this.handleChangePageSize} value={this.state.pagination.pageSize}>
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="0">All</option>
                        </FormControl>
                    </Col>
                </Row>
                <div>Resultaten  {(this.state.pagination.pageSize == '0' || this.state.pagination.pageSize > this.state.pagination.totalCount) ? this.state.pagination.totalCount : this.state.pagination.pageSize} van {this.state.pagination.totalCount}</div>
                <Table responsive striped bordered hover className="dataTable">
                    <thead>
                        <tr>
                            <th className={this.state.Title} onClick={() => this.handleSortingClick("Title")}>Titel</th>
                            <th className={this.state.DateCreated} onClick={() => this.handleSortingClick("DateCreated")}>Datum</th>
                            <th>Zichtbaar</th>
                            <th>Homepage</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        {opleiding !== undefined ? opleiding.map((comp) => {
                            let editUrl = `/admin/mededelingen/bewerken/${comp.id}`
                            return (<tr key={comp.id}>
                                <td>{comp.title}</td>
                                <td>{Api.formatDate(comp.dateCreated)}</td>
                                <td>{comp.visible == "True" ? 'ja' : 'nee'}</td>
                                <td>{comp.homepage == "True" ? 'ja' : 'nee'}</td>
                                <td>
                                    <ButtonGroup>
                                        <LinkContainer to={editUrl}>
                                            <Button bsSize="xsmall" className="edit">
                                                <Glyphicon glyph="pencil" />
                                            </Button>
                                        </LinkContainer>
                                        <Button bsSize="xsmall" className="delete" onClick={this.handleDelete(comp.id)}>
                                            <Glyphicon glyph="remove" />
                                        </Button>
                                    </ButtonGroup></td>
                            </tr >)
                        }) : null}
                    </tbody>
                </Table>
                <div className="paginationStyling">
                    <div style={{ float: 'left' }}>
                        {this.state.pagination.prevButton}
                    </div>
                    <div style={{ float: 'center' }}>
                        Pagina {this.state.pagination.currentPage} van {this.state.pagination.totalPages}
                    </div>
                    <div style={{ float: 'right' }}>
                        {this.state.pagination.nextButton}
                    </div>
                </div>
            </div>
        );
    }
}

export default MededelingOverzicht;


// WEBPACK FOOTER //
// ./src/components/Admin/Modules/Mededelingen/Overview.js